import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DrAaradhyaSharmacontent = () => {
  return (
    <>
      <Header />
      <div style={{ backgroundColor: "#fff9ee", padding: "40px 20px", paddingTop: "120px" }}>

             <div
                className="doctor-intro-container"
                style={{
                  maxWidth: "1100px",
                  margin: "auto",
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  gap: "32px",
                  textAlign: "left",
                }}
              >
               {/* Doctor Image */}
               <img
                 src="/Doctorprofile.png"
                 alt="Dr. Aaradhya Sharma"
                 style={{
                   width: "220px",
                   height: "220px",
                   borderRadius: "50%",
                   objectFit: "cover",
                   border: "3px solid #ddd",
                   flexShrink: 0,
                 }}
               />
           
               {/* Divider */}
               <div
                 className="vertical-divider"
                 style={{
                   width: "2px",
                   backgroundColor: "#ccc",
                   height: "100%",
                   minHeight: "160px",
                   display: "none",
                 }}
               ></div>
           
               <div
                 style={{
                   display: "flex",
                   flexDirection: "column",
                   gap: "16px",
                   flex: 1,
                   minWidth: "260px",
                 }}
               >
                 <div
                   style={{
                     display: "flex",
                     flexDirection: "column",
                     gap: "16px",
                   }}
                   className="content-container"
                 >
                   <div
                     style={{
                       display: "flex",
                       flexDirection: "column",
                       gap: "16px",
                     }}
                     className="inner-content"
                   >
                     
                     <div style={{ flex: 1 }}>
                       <h2 style={{ fontWeight: "bold", marginBottom: "8px" }}>
                         Dr Aaradhya Sharma
                       </h2>
                       <p style={{ margin: "4px 0", color: "#333" }}>
                         <strong>Specialization:</strong> Obstetrics & Gynaecology
                       </p>
                       <p style={{ margin: "4px 0", color: "#333" }}>
                         <strong>Experience:</strong> 11+ Years
                       </p>
                       <p style={{ margin: "4px 0", color: "#333" }}>
                         <strong>Degrees:</strong> MBBS, DGO, MD (Obs & Gyn)
                       </p>
                     </div>
                       <div
                         className="vertical-divider"
                         style={{
                           width: "2px",
                           backgroundColor: "#ccc",
                           height: "100%",
                           minHeight: "160px",
                           display: "none",
                         }}
                       ></div>
                     
                     <div style={{ flex: 1 }}>
                       <p
                         style={{
                           fontStyle: "italic",
                           fontSize: "15px",
                           lineHeight: "1.6",
                           color: "#444",
                           marginTop: "4px",
                         }}
                       >
                         "My goal is simple: to make you feel so safe and heard that you
                         forget you're talking to a doctor and feel like you're talking to
                         a friend who happens to know everything about pregnancy."
                       </p>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </div>

             <style>
                {`
                  @media (min-width: 768px) {
                    .vertical-divider {
                      display: block !important;
                    }
              
                    .inner-content {
                      flex-direction: row !important;
                    }
                  }
              
                  @media (max-width: 767px) {
                    .doctor-intro-container {
                      flex-direction: column;
                      align-items: center !important;
                      text-align: center !important;
                    }
              
                    .inner-content {
                      flex-direction: column !important;
                      align-items: center !important;
                      text-align: center !important;
                    }
              
                    .content-container {
                      align-items: center !important;
                      text-align: center !important;
                    }
                  }
                `}
              </style>

   
         <div style={{ padding: "40px 20px", maxWidth: "1100px", margin: "auto" }}>
           <h3>My Philosophy on Pregnancy Care</h3>
           <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
             I believe pregnancy is a journey of the heart as much as it is of the
             body. My role is to be a calm, steady presence. I focus on creating a
             space free of judgment, where you can share your deepest anxieties
             and your greatest joys. I believe in blending evidence-based medicine
             with a deep respect for a mother's intuition. We are partners in
             this, and your feelings and instincts are a vital part of our shared
             plan for a healthy, happy pregnancy.
           </p>
   
           <h3 style={{ marginTop: "32px" }}>Why I Chose Myprega</h3>
           <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
             Myprega's vision resonates deeply with how I've always wanted to
             practice medicine. In a traditional setup, time is a luxury. Here, the
             system is designed to foster connection. Myprega gives me the freedom
             and the tools to build the trusting, long-term relationships that I
             believe are essential for true maternal care.
           </p>
   
           <h3 style={{ marginTop: "32px" }}>Beyond the Clinic</h3>
           <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
             When I'm not with my patients, you can find me tending to my small
             balcony garden — there's something so hopeful about watching things
             grow. I'm an avid reader of classic literature and believe stories
             teach us more about humanity than anything else.
           </p>
         </div>
          <div style={{ backgroundColor: "#f9f7f2", padding: "40px 20px" }}>
            <div
            className="doctor-intro-container"
              style={{
                maxWidth: "1100px",
                margin: "auto",
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: "24px",
                paddingTop: "32px",
              }}
            >
              {/* Favourite Book */}
              <div style={{ flex: 1, minWidth: "250px" }}>
                <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
                  📖 Favourite Book
                </p>
                <p style={{ color: "#333" }}>
                  Sapiens - A Brief History of Humankind
                </p>
              </div>
          
              {/* Divider */}
              <div
                className="vertical-divider"
                style={{
                  width: "1px",
                  backgroundColor: "#ccc",
                  height: "auto",
                  minHeight: "50px",
                  alignSelf: "stretch",
                  display: "none",
                }}
              ></div>
          
              {/* Favourite Singer */}
              <div style={{ flex: 1, minWidth: "250px" }}>
                <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
                  🎵 Favourite Singer
                </p>
                <p style={{ color: "#333" }}>Lata Mangeshkar</p>
              </div>
          
              {/* Divider */}
              <div
                className="vertical-divider"
                style={{
                  width: "1px",
                  backgroundColor: "#ccc",
                  height: "auto",
                  minHeight: "50px",
                  alignSelf: "stretch",
                  display: "none",
                }}
              ></div>
          
              {/* Favourite Pastime */}
              <div style={{ flex: 1, minWidth: "250px" }}>
                <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
                  🍽️ Favourite Pastime
                </p>
                <p style={{ color: "#333" }}>
                  Semi-classical music, <br />
                  Gardening
                </p>
              </div>
            </div>
          </div>
      <Footer />
    </>
  );
};

export default DrAaradhyaSharmacontent;
